import dayjs from 'dayjs';
import { useState } from 'react';
import { useQuery } from 'react-query';
import { backend } from '../../axios/backend';
import ChevronLeft from '../../components/icons/ChevronLeft';
import ChevronRightOutline from '../../components/icons/ChevronRightOutline';
import PrettyLoader from '../../components/PrettyLoader';
import IconButton from '../../components/ui/IconButton';
import TableHeadCell from '../../components/ui/Table/TableHeadCell';
import { ProductOverview } from '../../types/product';

const LIMIT = 10;

const AllProducts = () => {
  const [skip, setSkip] = useState(0);
  const [sort, setSort] = useState<{ sortBy?: string; sortDirection?: number }>({
    sortBy: 'registeredAt',
    sortDirection: 1,
  });

  const query = useQuery(
    ['all-products', skip, sort.sortBy, sort.sortDirection],
    async () =>
      (
        await backend.get<{ count: number; products: ProductOverview[] }>('admin/wishes', {
          params: { limit: LIMIT, skip, sortBy: sort.sortBy, sortDirection: sort.sortDirection },
        })
      ).data,
  );

  return (
    <PrettyLoader useQueryResult={query}>
      {query.data && (
        <div className="space-y-2">
          <h2 className="text-white text-l">Anzahl Wünsche: {query.data.count}</h2>
          <div className="overflow-x-auto relative">
            <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
              <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                <tr>
                  <TableHeadCell name="imageUrl" sort={sort} onSort={setSort}>
                    Bild
                  </TableHeadCell>
                  <TableHeadCell name="name" sort={sort} onSort={setSort}>
                    Name
                  </TableHeadCell>
                  <TableHeadCell name="price" sort={sort} onSort={setSort}>
                    Preis
                  </TableHeadCell>
                  <TableHeadCell name="_idea_for" sort={sort} onSort={setSort}>
                    Typ
                  </TableHeadCell>
                  <TableHeadCell name="addedAt" sort={sort} onSort={setSort}>
                    Hinzugefügt
                  </TableHeadCell>
                  <TableHeadCell name="deletedAt" sort={sort} onSort={setSort}>
                    Gelöscht
                  </TableHeadCell>
                  <td></td>
                </tr>
              </thead>
              {query.data?.products.map((product) => (
                <tr key={product.id} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                  <td className="py-4 px-6">
                    {product.imageUrl ? (
                      <div
                        style={{
                          backgroundImage: `url(${product.imageUrl})`,
                          backgroundSize: 'cover',
                          backgroundPosition: 'center',
                        }}
                        className="h-10 w-10 rounded-full shrink-0"
                      />
                    ) : (
                      '-'
                    )}
                  </td>
                  <td className="py-4 px-6">{product.name}</td>
                  <td className="py-4 px-6">{product.price}</td>
                  <td className="py-4 px-6">{product.isIdea ? 'Idee' : 'Wunsch'}</td>
                  <td className="py-4 px-6">{dayjs(product.addedAt).format('DD.MM.YYYY')}</td>
                  <td className="py-4 px-6">
                    {product.deletedAt ? dayjs(product.deletedAt).format('DD.MM.YYYY') : '-'}
                  </td>
                </tr>
              ))}
            </table>
          </div>
          <div className="flex flex-row-reverse">
            <div className="flex flex-row items-center space-x-2">
              <IconButton
                Icon={ChevronLeft}
                onClick={() => {
                  setSkip((skip) => skip - LIMIT);
                }}
                isDisabled={skip - LIMIT < 0}
                variant="primary-muted"
              />
              <p className="text-white ">Seite {skip / LIMIT + 1}</p>
              <IconButton
                Icon={ChevronRightOutline}
                onClick={() => {
                  setSkip((skip) => skip + LIMIT);
                }}
                isDisabled={query.data.count < skip + LIMIT}
                variant="primary-muted"
              />
            </div>
          </div>
        </div>
      )}
    </PrettyLoader>
  );
};

export default AllProducts;
